class ContentHub {
  #rootElement;
  #contentElement;
  #progressBar;

  constructor(element) {
    if(element) {
      this.#rootElement = element;

      const progressBarElement = element.querySelector('[data-ch-progressbar]');
      if(progressBarElement) {
        this.#progressBar = progressBarElement;

        // Content element is optional
        const contentElement = this.#rootElement.matches('[data-ch-content]') && this.#rootElement || this.#rootElement.querySelector('[data-ch-content]');
        if(contentElement) {
          this.#contentElement = contentElement;
        }

        // Animating on scroll potentially causes performance issues. Adjust throttle as needed.
        window.addEventListener('scroll', this.#throttle(this.updateProgressBar.bind(this), 15));
      }
    }
  }

  /**
   * Throttles function calls
   *
   * @param {Function} fn - Function to throttle
   * @param {number} delay - Throttle delay in ms
   *
   * @returns {Function}
   */
  #throttle(fn, delay) {
    let time = Date.now();
    return () => {
      if((time + delay - Date.now()) <= 0) {
        fn();
        time = Date.now();
      }
    }
  }

  /**
   * Updates progress bar width based on scroll position.
   * If contentElement exists, starts counting progress when scrolling to contentElement
   * and maxes out when scrolling past the bottom of the contentElement.
   * Otherwise uses the entire page height for progress calculation.
   */
  updateProgressBar() {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const contentHeight = this.#contentElement ? this.#contentElement.offsetHeight : document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const contentOffsetTop = this.#contentElement ? this.#contentElement.offsetTop : 0;

    let progress = 0;
    const diff = winScroll - contentOffsetTop;
    if(diff <= 0) {
      progress = 0;
    } else {
      //check if we hav reached div bottom
      if(winScroll <= (contentOffsetTop + contentHeight)) {
        progress = (diff / contentHeight) * 100;
      } else {
        progress = 100;
      }
    }

    this.#progressBar.value = progress;
  }

}

/**
 * Initializes functionality
 *
 * @param {DOMElement} element - Content hub wrapper element
 */
export async function init(element) {
  console.log('contentHub.init()');
  new ContentHub(element);
}
